import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as Api from '../../../api';
import {
  postBlackListFailure,
  fetchBlackListListSuccess,
  fetchBlackListListFailure,
  fetchUserListSuccess,
  fetchUserListFailure,
  fetchUserListRequest,
  fetchBlackListCountSuccess,
  fetchBlackListCountFailure,
} from './actions';
import {
  POST_BLACKLIST_REQUEST,
  FETCH_BLACKLIST_LIST_REQUEST,
  UPDATE_BLACKLIST_REQUEST,
  REMOVE_BLACKLIST_REQUEST,
  FETCH_USERLIST_REQUEST,
  FETCH_BLACKLIST_COUNT_REQUEST,
  UPDATE_USER_REQUEST,
} from './action-types';
import { toast } from 'react-toastify';

/*
  Worker Saga: Fired on FETCH_TODO_REQUEST action
*/
function* postBlackListSaga(action: any): any {
  const { payload, filters, from } = action.payload;
  try {
    yield call(Api.createBlackList(payload));
    toast.success(' Blacklisted added succesfully');
  } catch (e: any) {
    try {
      const error = JSON.parse(e);
      if (error) {
        toast.error(error?.data.description);
      }
    } catch (error) {
      toast.error('Unknown error');
    }
    yield put(postBlackListFailure(JSON.parse(e)));
  }
  if (from === 'users') {
    yield put(fetchUserListRequest(filters));
  } else {
    const response = yield call(Api.getAllBlackList(filters));
    yield put(
      fetchBlackListListSuccess({
        BlackListList: response,
      }),
    );
  }
}

function* fetchBlackListListSaga(action: any): any {
  try {
    const response = yield call(Api.getAllBlackList(action.payload));
    yield put(
      fetchBlackListListSuccess({
        BlackListList: response,
      }),
    );
  } catch (e: any) {
    yield put(fetchBlackListListFailure(JSON.parse(e)));
  }
}

function* UpdateBlackListSaga(action: any): any {
  try {
    yield call(Api.deleteBlackList(action.payload));
    toast.success('UserList Updated Successfully');
  } catch (e: any) {
    try {
      const error = JSON.parse(e);
      if (error) {
        toast.error(error?.data.description);
      }
    } catch (error) {
      toast.error('Unknown error');
    }
  }
  const { id } = action.payload;
  yield put(fetchUserListRequest({ id, payload: { all_tier_versions: true, include_unpublished: true } }));
}
function* removeBlackListSaga(action: any): any {
  const { id, filters } = action.payload;
  try {
    yield call(Api.deleteBlackList({ id }));
  } catch (e: any) {
    try {
      const error = JSON.parse(e);
      if (error) {
        toast.error(error?.data?.description);
      }
    } catch (error) {
      toast.error('Unknown error');
    }
  }
  const response = yield call(Api.getAllBlackList(filters));
  yield put(
    fetchBlackListListSuccess({
      BlackListList: response,
    }),
  );
}

function* fetchUserListSaga(action: any): any {
  try {
    const res = Api.getAllUsers(action.payload);
    const response = yield call(res);
    yield put(fetchUserListSuccess(response));
  } catch (e: unknown) {
    yield put(
      fetchUserListFailure({
        error: e instanceof Error ? e.message : JSON.stringify(e),
      }),
    );
  }
}

function* fetchBlackListCountSaga(action: any): any {
  try {
    const response = yield call(Api.fetchBlackListCount(action.payload));
    yield put(fetchBlackListCountSuccess(response));
  } catch (e: unknown) {
    yield put(
      fetchBlackListCountFailure({
        error: e instanceof Error ? e.message : JSON.stringify(e),
      }),
    );
  }
}

function* updateUsersList(action: any): any {
  try {
    yield call(Api.updateUser(action.payload));
    toast.success('User Updated Successfully');
  } catch (e: any) {
    try {
      const error = JSON.parse(e);
      if (error) {
        toast.error(error?.data.description);
      }
    } catch (error) {
      toast.error('Unknown error');
    }
  }
  const { filterType } = action.payload;
  yield put(
    fetchUserListRequest({
      page: 1,
      limit: 25,
      search: '',
      status: filterType,
      include_ratings: true,
      include_topics: true,
      include_call_summary: true,
      include_user_safety: true,
      include_requests: true,
    }),
  );
}

function* paymentSaga() {
  yield all([
    takeLatest(POST_BLACKLIST_REQUEST, postBlackListSaga),
    takeLatest(FETCH_BLACKLIST_COUNT_REQUEST, fetchBlackListCountSaga),
    takeLatest(FETCH_BLACKLIST_LIST_REQUEST, fetchBlackListListSaga),
    takeLatest(UPDATE_BLACKLIST_REQUEST, UpdateBlackListSaga),
    takeLatest(REMOVE_BLACKLIST_REQUEST, removeBlackListSaga),
    takeLatest(FETCH_USERLIST_REQUEST, fetchUserListSaga),
    takeLatest(UPDATE_USER_REQUEST, updateUsersList),
  ]);
}

export default paymentSaga;
